module.exports = __webpack_public_path__ + "img/expostyle_0014_night_blue_pantone2965c.abbf4e54.jpg";